import { render, staticRenderFns } from "./RefineGlyphModal.vue?vue&type=template&id=af56c818"
import script from "./RefineGlyphModal.vue?vue&type=script&lang=js"
export * from "./RefineGlyphModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports